/**
 * BRXWelcomeScreen
 *
 * Mounts and drives the welcome surface shown to first-time visitors
 * of the embeddables wrapper section. Reveals the surface, attaches
 * click handlers to answer buttons, then calls onAnswered() when the
 * user selects any option.
 *
 * Usage (injected by BRXWrapperEntry):
 *   window.BRXWelcomeScreen.mount(sectionRoot, {
 *     onAnswered: function(answer) { ... }
 *   });
 */
(function () {
    function mount(root, options) {
        var welcomeEl = root ? root.querySelector('[data-intake-welcome]') : null;
        if (!welcomeEl) return;

        var onAnswered = (options && typeof options.onAnswered === 'function')
            ? options.onAnswered
            : function () {};

        welcomeEl.classList.remove('is-hidden');

        var buttons = welcomeEl.querySelectorAll('[data-intake-welcome-option]');
        for (var i = 0; i < buttons.length; i++) {
            (function (btn) {
                btn.addEventListener('click', function () {
                    var answer = btn.dataset.answer || btn.textContent.trim();
                    welcomeEl.classList.add('is-hidden');
                    onAnswered(answer);
                }, { once: true });
            }(buttons[i]));
        }

        var nextBtn = welcomeEl.querySelector('[data-intake-welcome-next]');
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                welcomeEl.classList.add('is-hidden');
                onAnswered('');
            }, { once: true });
        }
    }

    window.BRXWelcomeScreen = { mount: mount };
}());
